import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import * as _ from 'lodash-es';

import { useAxiosClient } from '../store/AxiosClient';
import { useEntityMeta } from '../store/EntityMeta';
import { useShowLoading } from '../../contexts/ShowLoading';
import { useInfoDialog } from '../../contexts/InfoDialog';

import { useStateWithGetter } from '../../utils/useStateWithGetter';
import { useThrowError } from '../../utils/useThrowError';
import { translate } from '../../utils/translations';

import { BffCustomReportsApi, useApi } from './generated';
import { HTTP_RESPONSE_ERROR_CODE, PAGE_PATH } from '../../constants';

export const usePostApplyToProduction = () => {
  const axiosClient = useAxiosClient();
  const customReportApi = useApi(axiosClient, BffCustomReportsApi);
  const navigate = useNavigate();
  const { templateId, templateRowVersion, setTemplateRowVersion } =
    useEntityMeta();
  const [isApiRequesting, setIsApiRequesting, getIsApiRequesting] =
    useStateWithGetter(false);
  const { setShowLoading } = useShowLoading();
  const infoDialog = useInfoDialog();
  const { throwError } = useThrowError();

  const postApplyToProduction = useCallback(
    async (newTemplateRowVersion?: string) => {
      if (getIsApiRequesting()) return;

      setIsApiRequesting(true);
      setShowLoading(true);

      try {
        const {
          data: { success, data },
        } = await customReportApi.customReportsPostApplyToProduction({
          templateId,
          templateRowVersion: newTemplateRowVersion ?? templateRowVersion,
        });
        if (success && data) {
          // rowVersionの更新
          setTemplateRowVersion(data.templateRowVersion);
          // 成功した場合は閲覧画面に遷移させる
          navigate(PAGE_PATH.DETAIL);
        } else {
          // 通信は成功したが本番適用に失敗したパターン
        }
      } catch (e) {
        // リクエスト自体が失敗したパターン（200以外）
        const errorCode = _.get(e, 'response.data.errorCode');
        if (errorCode === HTTP_RESPONSE_ERROR_CODE.MSG_ERROR_COMMON_003) {
          const ok = await infoDialog({
            message: translate('VALIDATE.MSG_ERROR_COMMON_003'),
          });
          if (ok) return;
        }

        throwError(e);
      } finally {
        setIsApiRequesting(false);
        setShowLoading(false);
      }
    },
    [customReportApi, templateId, templateRowVersion]
  );

  return { postApplyToProduction, isApiRequesting };
};
